const data = {  "grid": {
  "data": [
    {
      "batchId": 106,
      "periodId": 31,
      "optionShowDetails": true,
      "cellData": [
        {
          "type": "cell",
          "data": {
            "name": "Week",
            "displayValue": "[31] -Aug 03-Aug 09",
            "actualValue": "[31] -Aug 03-Aug 09",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Date",
            "displayValue": "09/08 06:30",
            "actualValue": "09/08 06:30",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "ICON",
            "displayValue": "",
            "actualValue": "",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NTG",
            "displayValue": "34.32%",
            "actualValue": "34.32",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Gross Cash",
            "displayValue": "£66,264.55",
            "actualValue": "£66,264.55",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "TktsRedeem",
            "displayValue": "£36,471.14",
            "actualValue": "£36,471.14",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Handpay",
            "displayValue": "£2,610.34",
            "actualValue": "£2,610.34",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Refills",
            "displayValue": "£2,770.00",
            "actualValue": "£2,770.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Promo",
            "displayValue": "£1,815.00",
            "actualValue": "£1,815.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Other",
            "displayValue": "£6.00",
            "actualValue": "£6.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "MCDeduct",
            "displayValue": "£43,672.48",
            "actualValue": "£43,672.48",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetCash",
            "displayValue": "£22,592.07",
            "actualValue": "£22,592.07",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PurchTkts",
            "displayValue": "£150.30",
            "actualValue": "£150.30",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PromoTkts",
            "displayValue": "£0.00",
            "actualValue": "£0.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetIncome",
            "displayValue": "£22,742.37",
            "actualValue": "£22,742.37",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteDeduct",
            "displayValue": "£7,519.72",
            "actualValue": "£7,519.72",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Banked",
            "displayValue": "£15,072.35",
            "actualValue": "£15,072.35",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteIncome",
            "displayValue": "£7,040.30",
            "actualValue": "£7,040.30",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteNetIncome",
            "displayValue": "£22,112.65",
            "actualValue": "£22,112.65",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "CashVar",
            "displayValue": "£708.50",
            "actualValue": "£708.50",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        }
      ]
    },
    {
      "batchId": 105,
      "periodId": 30,
      "optionShowDetails": true,
      "cellData": [
        {
          "type": "cell",
          "data": {
            "name": "Week",
            "displayValue": "[30] -Jul 27-Aug 02",
            "actualValue": "[30] -Jul 27-Aug 02",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Date",
            "displayValue": "02/08 06:04",
            "actualValue": "02/08 06:04",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "ICON",
            "displayValue": "",
            "actualValue": "",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NTG",
            "displayValue": "24.14%",
            "actualValue": "24.14",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Gross Cash",
            "displayValue": "£48,225.40",
            "actualValue": "£48,225.40",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "TktsRedeem",
            "displayValue": "£30,427.30",
            "actualValue": "£30,427.30",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Handpay",
            "displayValue": "£2,996.93",
            "actualValue": "£2,996.93",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Refills",
            "displayValue": "£1,811.00",
            "actualValue": "£1,811.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Promo",
            "displayValue": "£1,445.00",
            "actualValue": "£1,445.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Other",
            "displayValue": "£6.00",
            "actualValue": "£6.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "MCDeduct",
            "displayValue": "£36,686.23",
            "actualValue": "£36,686.23",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetCash",
            "displayValue": "£11,539.17",
            "actualValue": "£11,539.17",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PurchTkts",
            "displayValue": "£101.20",
            "actualValue": "£101.20",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PromoTkts",
            "displayValue": "£0.00",
            "actualValue": "£0.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetIncome",
            "displayValue": "£11,640.37",
            "actualValue": "£11,640.37",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteDeduct",
            "displayValue": "£6,326.94",
            "actualValue": "£6,326.94",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Banked",
            "displayValue": "£5,212.23",
            "actualValue": "£5,212.23",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteIncome",
            "displayValue": "£5,699.20",
            "actualValue": "£5,699.20",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteNetIncome",
            "displayValue": "£10,911.43",
            "actualValue": "£10,911.43",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "CashVar",
            "displayValue": "£986.00",
            "actualValue": "£986.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        }
      ]
    },
    {
      "batchId": 104,
      "periodId": 29,
      "optionShowDetails": true,
      "cellData": [
        {
          "type": "cell",
          "data": {
            "name": "Week",
            "displayValue": "[29] -Jul 20-Jul 26",
            "actualValue": "[29] -Jul 20-Jul 26",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Date",
            "displayValue": "26/07 06:20",
            "actualValue": "26/07 06:20",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "ICON",
            "displayValue": "",
            "actualValue": "",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NTG",
            "displayValue": "27.69%",
            "actualValue": "27.69",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Gross Cash",
            "displayValue": "£71,003.50",
            "actualValue": "£71,003.50",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "TktsRedeem",
            "displayValue": "£41,555.36",
            "actualValue": "£41,555.36",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Handpay",
            "displayValue": "£4,486.17",
            "actualValue": "£4,486.17",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Refills",
            "displayValue": "£3,442.00",
            "actualValue": "£3,442.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Promo",
            "displayValue": "£1,860.00",
            "actualValue": "£1,860.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Other",
            "displayValue": "£42.00",
            "actualValue": "£42.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "MCDeduct",
            "displayValue": "£51,385.53",
            "actualValue": "£51,385.53",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetCash",
            "displayValue": "£19,617.97",
            "actualValue": "£19,617.97",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PurchTkts",
            "displayValue": "£45.00",
            "actualValue": "£45.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PromoTkts",
            "displayValue": "£0.00",
            "actualValue": "£0.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetIncome",
            "displayValue": "£19,662.97",
            "actualValue": "£19,662.97",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteDeduct",
            "displayValue": "£8,792.16",
            "actualValue": "£8,792.16",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Banked",
            "displayValue": "£10,825.81",
            "actualValue": "£10,825.81",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteIncome",
            "displayValue": "£8,074.00",
            "actualValue": "£8,074.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteNetIncome",
            "displayValue": "£18,899.81",
            "actualValue": "£18,899.81",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "CashVar",
            "displayValue": "£-317.48",
            "actualValue": "£-317.48",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        }
      ]
    },
    {
      "batchId": 103,
      "periodId": 28,
      "optionShowDetails": true,
      "cellData": [
        {
          "type": "cell",
          "data": {
            "name": "Week",
            "displayValue": "[28] -Jul 13-Jul 19",
            "actualValue": "[28] -Jul 13-Jul 19",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Date",
            "displayValue": "19/07 06:37",
            "actualValue": "19/07 06:37",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "ICON",
            "displayValue": "",
            "actualValue": "",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NTG",
            "displayValue": "31.04%",
            "actualValue": "31.04",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Gross Cash",
            "displayValue": "£58,642.50",
            "actualValue": "£58,642.50",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "TktsRedeem",
            "displayValue": "£31,569.00",
            "actualValue": "£31,569.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Handpay",
            "displayValue": "£3,997.36",
            "actualValue": "£3,997.36",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Refills",
            "displayValue": "£2,827.00",
            "actualValue": "£2,827.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Promo",
            "displayValue": "£2,045.00",
            "actualValue": "£2,045.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Other",
            "displayValue": "£10.00",
            "actualValue": "£10.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "MCDeduct",
            "displayValue": "£40,448.36",
            "actualValue": "£40,448.36",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetCash",
            "displayValue": "£18,194.14",
            "actualValue": "£18,194.14",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PurchTkts",
            "displayValue": "£10.00",
            "actualValue": "£10.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PromoTkts",
            "displayValue": "£0.00",
            "actualValue": "£0.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetIncome",
            "displayValue": "£18,204.14",
            "actualValue": "£18,204.14",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteDeduct",
            "displayValue": "£6,446.33",
            "actualValue": "£6,446.33",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Banked",
            "displayValue": "£11,747.81",
            "actualValue": "£11,747.81",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteIncome",
            "displayValue": "£5,997.00",
            "actualValue": "£5,997.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteNetIncome",
            "displayValue": "£17,744.81",
            "actualValue": "£17,744.81",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "CashVar",
            "displayValue": "£802.34",
            "actualValue": "£802.34",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        }
      ]
    },
    {
      "batchId": 102,
      "periodId": 27,
      "optionShowDetails": true,
      "cellData": [
        {
          "type": "cell",
          "data": {
            "name": "Week",
            "displayValue": "[27] -Jul 06-Jul 12",
            "actualValue": "[27] -Jul 06-Jul 12",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Date",
            "displayValue": "12/07 06:16",
            "actualValue": "12/07 06:16",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "control",
          "data": {
            "text": "",
            "id": 0,
            "type": 12,
            "data": null,
            "defaultText": "file alternate outline",
            "defaultList": null,
            "defaultDate": "0001-01-01T00:00:00",
            "isEditable": true,
            "isRequired": true,
            "code": "ICON",
            "isHidden": false,
            "doRefresh": false,
            "regex": null,
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "maxLength": 0,
            "setFocus": false,
            "placeHolder": "",
            "checkDenom": 0,
            "entryPattern": null,
            "isCurrency": true
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NTG",
            "displayValue": "30.51%",
            "actualValue": "30.51",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Gross Cash",
            "displayValue": "£47,714.85",
            "actualValue": "£47,714.85",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "TktsRedeem",
            "displayValue": "£28,577.20",
            "actualValue": "£28,577.20",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Handpay",
            "displayValue": "£1,016.71",
            "actualValue": "£1,016.71",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Refills",
            "displayValue": "£1,944.00",
            "actualValue": "£1,944.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Promo",
            "displayValue": "£1,675.00",
            "actualValue": "£1,675.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Other",
            "displayValue": "£5.00",
            "actualValue": "£5.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "MCDeduct",
            "displayValue": "£33,217.91",
            "actualValue": "£33,217.91",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetCash",
            "displayValue": "£14,496.94",
            "actualValue": "£14,496.94",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PurchTkts",
            "displayValue": "£60.00",
            "actualValue": "£60.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PromoTkts",
            "displayValue": "£0.00",
            "actualValue": "£0.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetIncome",
            "displayValue": "£14,556.94",
            "actualValue": "£14,556.94",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteDeduct",
            "displayValue": "£7,198.58",
            "actualValue": "£7,198.58",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Banked",
            "displayValue": "£7,298.36",
            "actualValue": "£7,298.36",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteIncome",
            "displayValue": "£5,392.00",
            "actualValue": "£5,392.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteNetIncome",
            "displayValue": "£12,690.36",
            "actualValue": "£12,690.36",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "CashVar",
            "displayValue": "£-468.30",
            "actualValue": "£-468.30",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 255,
              "a": 255,
              "isKnownColor": true,
              "isEmpty": false,
              "isNamedColor": true,
              "isSystemColor": false,
              "name": "Blue"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        }
      ]
    },
    {
      "batchId": 101,
      "periodId": 26,
      "optionShowDetails": true,
      "cellData": [
        {
          "type": "cell",
          "data": {
            "name": "Week",
            "displayValue": "[26] -Jun 29-Jul 05",
            "actualValue": "[26] -Jun 29-Jul 05",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Date",
            "displayValue": "05/07 06:06",
            "actualValue": "05/07 06:06",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "ICON",
            "displayValue": "",
            "actualValue": "",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NTG",
            "displayValue": "21.43%",
            "actualValue": "21.43",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Gross Cash",
            "displayValue": "£61,320.80",
            "actualValue": "£61,320.80",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "TktsRedeem",
            "displayValue": "£41,806.80",
            "actualValue": "£41,806.80",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Handpay",
            "displayValue": "£2,172.78",
            "actualValue": "£2,172.78",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Refills",
            "displayValue": "£2,846.00",
            "actualValue": "£2,846.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Promo",
            "displayValue": "£1,675.00",
            "actualValue": "£1,675.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Other",
            "displayValue": "£30.00",
            "actualValue": "£30.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "MCDeduct",
            "displayValue": "£48,530.58",
            "actualValue": "£48,530.58",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetCash",
            "displayValue": "£12,790.22",
            "actualValue": "£12,790.22",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PurchTkts",
            "displayValue": "£351.10",
            "actualValue": "£351.10",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PromoTkts",
            "displayValue": "£0.00",
            "actualValue": "£0.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetIncome",
            "displayValue": "£13,141.32",
            "actualValue": "£13,141.32",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteDeduct",
            "displayValue": "£7,397.52",
            "actualValue": "£7,397.52",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Banked",
            "displayValue": "£5,392.70",
            "actualValue": "£5,392.70",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteIncome",
            "displayValue": "£7,092.10",
            "actualValue": "£7,092.10",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteNetIncome",
            "displayValue": "£12,484.80",
            "actualValue": "£12,484.80",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "CashVar",
            "displayValue": "£538.90",
            "actualValue": "£538.90",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        }
      ]
    },
    {
      "batchId": 100,
      "periodId": 25,
      "optionShowDetails": true,
      "cellData": [
        {
          "type": "cell",
          "data": {
            "name": "Week",
            "displayValue": "[25] -Jun 22-Jun 28",
            "actualValue": "[25] -Jun 22-Jun 28",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Date",
            "displayValue": "28/06 05:47",
            "actualValue": "28/06 05:47",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "ICON",
            "displayValue": "",
            "actualValue": "",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NTG",
            "displayValue": "22.51%",
            "actualValue": "22.51",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Gross Cash",
            "displayValue": "£40,871.10",
            "actualValue": "£40,871.10",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "TktsRedeem",
            "displayValue": "£27,421.70",
            "actualValue": "£27,421.70",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Handpay",
            "displayValue": "£1,292.24",
            "actualValue": "£1,292.24",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Refills",
            "displayValue": "£1,200.00",
            "actualValue": "£1,200.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Promo",
            "displayValue": "£1,705.00",
            "actualValue": "£1,705.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Other",
            "displayValue": "£73.00",
            "actualValue": "£73.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "MCDeduct",
            "displayValue": "£31,691.94",
            "actualValue": "£31,691.94",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetCash",
            "displayValue": "£9,179.16",
            "actualValue": "£9,179.16",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PurchTkts",
            "displayValue": "£20.00",
            "actualValue": "£20.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PromoTkts",
            "displayValue": "£0.00",
            "actualValue": "£0.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetIncome",
            "displayValue": "£9,199.16",
            "actualValue": "£9,199.16",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteDeduct",
            "displayValue": "£7,619.46",
            "actualValue": "£7,619.46",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Banked",
            "displayValue": "£1,559.70",
            "actualValue": "£1,559.70",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteIncome",
            "displayValue": "£6,071.00",
            "actualValue": "£6,071.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteNetIncome",
            "displayValue": "£7,630.70",
            "actualValue": "£7,630.70",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "CashVar",
            "displayValue": "£664.45",
            "actualValue": "£664.45",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        }
      ]
    },
    {
      "batchId": 99,
      "periodId": 24,
      "optionShowDetails": true,
      "cellData": [
        {
          "type": "cell",
          "data": {
            "name": "Week",
            "displayValue": "[24] -Jun 15-Jun 21",
            "actualValue": "[24] -Jun 15-Jun 21",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Date",
            "displayValue": "21/06 06:42",
            "actualValue": "21/06 06:42",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "ICON",
            "displayValue": "",
            "actualValue": "",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NTG",
            "displayValue": "23.91%",
            "actualValue": "23.91",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Gross Cash",
            "displayValue": "£56,354.20",
            "actualValue": "£56,354.20",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "TktsRedeem",
            "displayValue": "£36,215.15",
            "actualValue": "£36,215.15",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Handpay",
            "displayValue": "£2,894.30",
            "actualValue": "£2,894.30",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Refills",
            "displayValue": "£1,865.00",
            "actualValue": "£1,865.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Promo",
            "displayValue": "£1,905.00",
            "actualValue": "£1,905.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Other",
            "displayValue": "£1.00",
            "actualValue": "£1.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "MCDeduct",
            "displayValue": "£42,880.45",
            "actualValue": "£42,880.45",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetCash",
            "displayValue": "£13,473.75",
            "actualValue": "£13,473.75",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PurchTkts",
            "displayValue": "£0.00",
            "actualValue": "£0.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "PromoTkts",
            "displayValue": "£0.00",
            "actualValue": "£0.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "NetIncome",
            "displayValue": "£13,473.75",
            "actualValue": "£13,473.75",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteDeduct",
            "displayValue": "£9,172.51",
            "actualValue": "£9,172.51",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "Banked",
            "displayValue": "£4,301.24",
            "actualValue": "£4,301.24",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteIncome",
            "displayValue": "£7,880.00",
            "actualValue": "£7,880.00",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "SiteNetIncome",
            "displayValue": "£12,181.24",
            "actualValue": "£12,181.24",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        },
        {
          "type": "cell",
          "data": {
            "name": "CashVar",
            "displayValue": "£-65.81",
            "actualValue": "£-65.81",
            "backColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "foreColour": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 0,
              "isKnownColor": false,
              "isEmpty": true,
              "isNamedColor": false,
              "isSystemColor": false,
              "name": "0"
            },
            "hide": false,
            "isHeader": false,
            "isClickable": false
          }
        }
      ]
    }
  ],
  "headerDef": [
    {
      "text": "Week",
      "alignment": 0,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Date",
      "alignment": 0,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "N2G",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Gross Cash",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Tkts Redeemed",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Handpays",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Refills",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Promo Cash",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Other",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Total M/c Deductions",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "M/c Net Cash",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Purchased Tkts",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Promo Tkts",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Mc/ Net Income",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Site Deductions",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Cash Banked",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Site Income",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Site Net Income",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    },
    {
      "text": "Cash Variance",
      "alignment": 1,
      "backColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      },
      "foreColour": {
        "r": 0,
        "g": 0,
        "b": 0,
        "a": 0,
        "isKnownColor": false,
        "isEmpty": true,
        "isNamedColor": false,
        "isSystemColor": false,
        "name": "0"
      }
    }
  ],
  "rowDef": [
    {
      "alignment": 0
    },
    {
      "alignment": 0
    },
    {
      "alignment": 1
    },
    {
      "alignment": 1
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    },
    {
      "alignment": 2
    }
  ],
  "span": null
},
  "summary": {
    "data": [
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "EFT SESSIONS",
              "actualValue": "EFT SESSIONS",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "control",
            "data": {
              "text": "",
              "id": 0,
              "type": 10,
              "data": null,
              "defaultText": "TRUE",
              "defaultList": null,
              "defaultDate": "0001-01-01T00:00:00",
              "isEditable": true,
              "isRequired": true,
              "code": "SHOWEFT",
              "isHidden": false,
              "doRefresh": false,
              "regex": null,
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "maxLength": 0,
              "setFocus": false,
              "entryPattern": null
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "Quantity",
              "actualValue": "Quantity",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "1",
              "actualValue": "1",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "EFT In",
              "actualValue": "EFT In",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "£10.00",
              "actualValue": "£10.00",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "EFT Out",
              "actualValue": "EFT Out",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "£10.00",
              "actualValue": "£10.00",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "Net EFT",
              "actualValue": "Net EFT",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "£0.00",
              "actualValue": "£0.00",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "",
              "actualValue": "",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "",
              "actualValue": "",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "CASH SESSIONS",
              "actualValue": "CASH SESSIONS",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "control",
            "data": {
              "text": "",
              "id": 0,
              "type": 10,
              "data": null,
              "defaultText": "TRUE",
              "defaultList": null,
              "defaultDate": "0001-01-01T00:00:00",
              "isEditable": true,
              "isRequired": true,
              "code": "SHOWCASH",
              "isHidden": false,
              "doRefresh": false,
              "regex": null,
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "maxLength": 0,
              "setFocus": false,
              "entryPattern": null
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "Quantity",
              "actualValue": "Quantity",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "0",
              "actualValue": "0",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "Cash In",
              "actualValue": "Cash In",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "£0.00",
              "actualValue": "£0.00",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "Cash Out",
              "actualValue": "Cash Out",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "£0.00",
              "actualValue": "£0.00",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "Net Cash",
              "actualValue": "Net Cash",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "£0.00",
              "actualValue": "£0.00",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "",
              "actualValue": "",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "",
              "actualValue": "",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "Notes In",
              "actualValue": "Notes In",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "£0.00",
              "actualValue": "£0.00",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "Coins In",
              "actualValue": "Coins In",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "£0.00",
              "actualValue": "£0.00",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "Tickets In",
              "actualValue": "Tickets In",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "£0.00",
              "actualValue": "£0.00",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "Notes Out",
              "actualValue": "Notes Out",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "£0.00",
              "actualValue": "£0.00",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "Coins Out",
              "actualValue": "Coins Out",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "£0.00",
              "actualValue": "£0.00",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "Tickets Out",
              "actualValue": "Tickets Out",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "£0.00",
              "actualValue": "£0.00",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      },
      {
        "cellData": [
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "Handpay",
              "actualValue": "Handpay",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          },
          {
            "type": "cell",
            "data": {
              "name": "",
              "displayValue": "£0.00",
              "actualValue": "£0.00",
              "backColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "foreColour": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0,
                "isKnownColor": false,
                "isEmpty": true,
                "isNamedColor": false,
                "isSystemColor": false,
                "name": "0"
              },
              "hide": false,
              "isHeader": false,
              "isClickable": false
            }
          }
        ]
      }
    ],
    "headerDef": [
      {
        "text": "",
        "alignment": 0
      },
      {
        "text": "",
        "alignment": 1
      }
    ],
    "rowDef": [
      {
        "alignment": 0
      },
      {
        "alignment": 2
      }
    ]
  }
  }
  
  export default data;
  
